import {Grid} from "@material-ui/core";
import AxlAutocomplete from "../../AxlAutocomplete";
import AxlDatePicker from "../../AxlDatePicker";
import moment from "moment/moment";
import AxlSearchBox from "../../AxlSearchBox";
import React, {useEffect} from "react";
import _ from "lodash";



function ClaimsListFilter(props) {

    const { isBrandsEnabled, handleChangeDate, receivedDate, clientProfileOptions, selectedClientProfileOptions,
        handleBrandsSelectChange, changeSearch, onSearchEnter,
        handleOnOpen, handleOnClose,
        shipmentQuery, clearSearch } = props;


return (
    <Grid container direction="row" alignItems="center">
        { isBrandsEnabled &&
            <Grid item xs={2} style={{paddingRight: "10px"}}>
                <AxlAutocomplete multiple
                                 size={'small'}
                                 options={_.sortBy(clientProfileOptions, opt => opt.value)}
                                 inlineLabel={selectedClientProfileOptions?.length > 0 ? 'Brands' : 'All Brands'}
                                 limitTags={1}
                                 // disableClearable
                                 disableCloseOnSelect
                                 onOpen={handleOnOpen}
                                 onClose={handleOnClose}
                                 onChange={(e, selected, reason) => handleBrandsSelectChange(e,selected,reason)}
                                 value={selectedClientProfileOptions}
                                 getOptionLabel={(option) => option.label}
                                 getOptionSelected={(option, value) => option.value === value.value || ''}
                                 placeholder={selectedClientProfileOptions?.length > 0 ? '' : 'Select Brands'}
                                 style={{background: "white"}}
                />

            </Grid>
        }
        <Grid item xs={2} style={{paddingRight:"10px"}}>
            <AxlDatePicker
                label="Received Date"
                handleChange={handleChangeDate}
                format="MM/DD/yyyy" value={receivedDate ? moment(receivedDate) : null}
                variant="inline"
                inputVariant="outlined"
                size="small"
                disableToolbar={true}
                maxDate={moment()}
                style={{width:"100%", background:"white" }}
            />
        </Grid>
        <Grid item style={{flex:1}}>
            <AxlSearchBox
                placeholder={"Search existing claim by shipment ID..."}
                onChange={changeSearch}
                style={{ width: "100%", height: "45px" }}
                onEnter={onSearchEnter}
                value={shipmentQuery}
                clearValue={clearSearch}
            >Received Date</AxlSearchBox>
        </Grid>
    </Grid>
    )
 }

 export default ClaimsListFilter;
